//#region IMPORTS
import env from './env';
import React, { Component } from 'react';
import language from './es';

import { Auth } from 'aws-amplify';
import jwt_decode from 'jwt-decode';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
//import AuthHelper from './auth_helper'
//#endregion IMPORTS

// Colores sacados de las variables del tema (tokens.css / themes.css), para que el
// aviso de sesion se vea bien en cualquier tema, incluidos los oscuros.
const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: 'var(--c-surface)',
    color: 'var(--c-ink)',
    border: '1px solid var(--c-line)',
    borderRadius: 'var(--r-md)',
    boxShadow: 'var(--sh-3)',
  },
  divTitleSession: {
    textAlign: 'center',
    color: 'var(--c-ink-soft)',
    '& h2': {
      margin: theme.spacing(1),
      fontWeight: 'bold',
      color: 'var(--c-brand-600)'
    },
  },
  listItemLive: {
    backgroundColor: 'var(--c-brand-100)',
    color: 'var(--c-ink)',
    borderColor: 'var(--c-line)',
    '&:hover': {
      backgroundColor: 'var(--c-brand-600)',
      color: 'var(--c-on-brand)',
    }
  },
  listItemDeath: {
    color: 'var(--c-ink)',
    '&:hover': {
      backgroundColor: 'var(--c-err)',
      color: 'var(--c-on-brand)',
    }
  },
  refreshSession: {
    backgroundColor: 'var(--c-surface)',
    color: 'var(--c-brand-600)',
  },
  closeSession: {
    backgroundColor: 'var(--c-err-bg)',
    color: 'var(--c-err)'
  }
}));

function SimpleDialog(props) {
  const classes = useStyles();
  const { onClose, timeOut, open } = props;

  const handleClose = () => {
    //onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} classes={{ paper: classes.paper }}>
      <DialogTitle>
        <div className={classes.divTitleSession}>
          <span>{language.messages.sessionUser.lbTitle}</span>
          <h2>{timeOut}</h2>
          <span>{language.messages.sessionUser.lbSeconds}</span>
        </div>
      </DialogTitle>
      <List>
        <ListItem button divider onClick={() => handleListItemClick('live')} className={classes.listItemLive}>
          <ListItemAvatar>
            <Avatar className={classes.refreshSession}>
              <CheckCircleIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={language.messages.sessionUser.btnLive} />
        </ListItem>
      <ListItem button onClick={() => handleListItemClick('death')} className={classes.listItemDeath}>
          <ListItemAvatar>
            <Avatar className={classes.closeSession}>
              <CancelIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={language.messages.sessionUser.btnDeath} />
        </ListItem>
      </List>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  timeOut: PropTypes.number.isRequired,
};

class SessionConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: ['live', 'death'],
      open: false,
      count: 0,
      delay: 1000
    };
  }
  componentDidMount() {
    clearInterval(this.interval);
    Auth.currentSession()
    .then(data => {
      this.getToken(data);
      if (document.documentElement.className.includes("nav-open")) {
        document.documentElement.classList.toggle("nav-open");
      }
    })
    .catch((error) => {
      console.log(error);
      this.logoutSessionAD();
    });
    this.interval = setInterval(this.tick, this.state.delay);
  }
  componentDidUpdate(prevProps, prevState) {
    if(prevState.delay !== this.state.delay) {
      clearInterval(this.interval);
      this.interval = setInterval(this.tick, this.state.delay);
    }
    if(prevState.count > 0) {
      switch (prevState.count) {
        case 60:
          console.log('Refresh yor token message')
          break;
        case 25:
          if(this.state.open === false) {
            this.setState({
              open: true
            });
          }
          break;
        case 1:
          this.logoutSessionAD();
          break;
        default:
          break;
      }
    }
  }

  getToken = (data) => {
    const token = data.idToken.jwtToken;
    if (jwt_decode(token).exp > Date.now() / 1000) {
        //var diff = Math.abs(new Date(parseInt(jwt_decode(token).exp * 1000)) - new Date());
        //var seconds = Math.floor((diff/1000));
        this.setState({
          count: Number.parseInt(env.app.sessionTimeUser)
        });
    }
  }
  logoutSessionAD = () => {
    try {
      Auth.signOut().catch((error) => console.log(error));
      this.removeSession();
    } catch(error) {
      console.log(error);
      this.removeSession();
    }
  }
  removeSession = () => {
    window.sessionStorage.removeItem('username');
    window.sessionStorage.removeItem('name');
    window.sessionStorage.removeItem('user');
    window.sessionStorage.removeItem('menu');
    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem('node');
    window.sessionStorage.removeItem('menuId');
    window.location.href = '/login';
  }
  tick = () =>{
    this.setState((prevState) => ({
      count: prevState.count - 1
    }));
  }
  handleClose = (value) => {
    switch(value) {
      case 'live':
        this.refreshCurrentSession();
        this.setState({
          open: false
        });
        clearInterval(this.interval);
        this.interval = setInterval(this.tick, this.state.delay);
      break;
      case 'death':
        this.logoutSessionAD();
      break;
      default:
      break;
    }
  }

  refreshCurrentSession = () => {
    Auth.currentSession()
    .then(data => {
      this.getToken(data);
    })
    .catch((error) => {
      console.log(error);
      this.logoutSessionAD();
    });
  }

  onRefreshCurrentSession () {
    this.refreshCurrentSession();
    clearInterval(this.interval);
    this.interval = setInterval(this.tick, this.state.delay);
  }

  render(){
    return(
      <div>
        {/* <span>{this.state.count}</span> */}
        <SimpleDialog timeOut={this.state.count} open={this.state.open} onClose={this.handleClose} />
      </div>
    )}
}
export default SessionConfig;
